const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetSelector' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset type...</option>
								</select>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<span class="control-status-icon"></span>
								<select
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
								>
									<option value="">Select an asset...</option>
								</select>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>
`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input"
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<p class="control control-status is-fullwidth select">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									disabled="disabled"
								></div>
							</p>
						</div>
					</div>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-PhysicalAssetSelector`,
			DefaultInputExtensions: [ 'PhysicalAssetDisplay' ],
			Template: /*HTML*/`
			<!-- InputType PhysicalAssetSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="columns">
					<div class="column is-4 {~ShowTypeSelector:Record~}">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Type"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type" class="label">Asset Type</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Type"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}-Asset"
							type="hidden"
							tabindex="-1"
							{~D:Record.Macro.InputChangeHandler~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						/>
						<label for="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset" class="label">{~LabelWithChips:Record~}</label>
						<div class="field">
							<div class="control">
								<div
									id="SELECT-FOR-{~D:Record.Macro.RawHTMLID~}-Asset"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
